import React, {useContext, useEffect, useState} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import PictureList from 'components/pictures/list/PictureList';
import 'styles/pictures/PicturesPage.css';
import {PicturesContext} from 'util/image/PictureContext';
import UniversalOptionsList from 'components/universal/UniversalOptionsList';
import {useSessionConfiguration} from 'util/SessionConfigurationContext';
import {useSwipeable} from 'react-swipeable';
import {usePopup} from 'popup/PopupContext';
import UniversalEmptyPageHeader from 'components/universal/UniversalEmptyPageHeader';
import {UserContext} from "../../user/UserContext";

const topUrl = '/';
const trendingUrl = '/trending';

const PicturesPage = ({component}) => {
    const location = useLocation();
    const navigate = useNavigate();
    const [pictureMetadata, setPictureMetadata] = useState(null);
    const isToggled = component === 'TRENDING';
    const {sortedByAmount, sortedByTrending} = useContext(PicturesContext);
    const {isDesktopView, innerWidth} = useSessionConfiguration();
    const [initialIndex, setInitialIndex] = useState(-1);
    const [twoFloorHeader, setTwoFloorHeader] = useState(false);
    const {isPopupOpen} = usePopup();
    const {isCashTenant} = useContext(UserContext);

    const imgParam = new URLSearchParams(location.search).get('img') || null;
    const indexParam = new URLSearchParams(location.search).get('index') || null;

    const handlers = useSwipeable({
        onSwipedLeft: () => {
            if (!isPopupOpen && component !== 'TRENDING') {
                navigate(trendingUrl);
            }
        },
        onSwipedRight: () => {
            if (!isPopupOpen && component !== 'TOP') {
                navigate(topUrl);
            }
        },
        preventDefaultTouchmoveEvent: true,
        trackMouse: true,
    });

    useEffect(() => {
        setTwoFloorHeader(innerWidth < 540);
        console.log(`innerWidth: ${innerWidth}, twoFloorHeader: ${twoFloorHeader}`);
    }, [innerWidth]);

    const handleItemClick = (name) => {
        const route = name === 'TOP' ? topUrl : trendingUrl;
        if (location.pathname !== route) {
            navigate(route);
        }
    };

    useEffect(() => {
        const fetchPictures = async () => {
            let data;
            switch (component) {
                case 'TOP':
                    data = sortedByAmount;
                    break;
                case 'TRENDING':
                    data = sortedByTrending;
                    break;
                default:
                    throw new Error('Invalid component');
            }
            setPictureMetadata(data);
        };
        fetchPictures();
    }, [component, sortedByAmount, sortedByTrending]);

    useEffect(() => {
        if (!pictureMetadata) {
            return;
        }
        if (imgParam) {
            const index = pictureMetadata.findIndex(picture => picture.id === imgParam);
            if (index !== -1) {
                setInitialIndex(index);
            }
        } else if (indexParam) {
            const index = parseInt(indexParam);
            if (index >= 0 && index < pictureMetadata.length) {
                setInitialIndex(index);
            }
        } else {
            setInitialIndex(-1);
        }
    }, [imgParam, indexParam, pictureMetadata]);

    return (
        <div>
            <UniversalEmptyPageHeader
                image={isDesktopView ? 'logo' : (isCashTenant ? 'logo-flextagram' : 'logo-flexagren')}
                desktopHeaderScale={1.05}
                translateX={isDesktopView ? -6 : 0}>
                {!twoFloorHeader && (
                    <div style={{display: twoFloorHeader ? 'block' : 'flex', alignItems: 'center'}}>
                        {!isDesktopView && <div style={{width: '120px'}}/>}
                        <UniversalOptionsList
                            options={['TOP', 'TRENDING']}
                            onOptionClick={handleItemClick}
                            optionalCurrentOption={component}
                            isHeader={true}
                        />
                    </div>
                )}
            </UniversalEmptyPageHeader>

            <div {...handlers}>
                {pictureMetadata && isToggled &&
                    <PictureList pictureMetadata={pictureMetadata} listType={component} initialIndex={initialIndex}/>
                }
                {pictureMetadata && !isToggled &&
                    <PictureList pictureMetadata={pictureMetadata} listType={component} initialIndex={initialIndex}/>
                }
            </div>
        </div>
    );
};

export default PicturesPage;